import { createAsyncThunk } from '@reduxjs/toolkit'
import { API_BASE_URL } from '../../constant'
import axios from 'axios'

axios.defaults.withCredentials = true;

/**
 * FETCH CART DETAILS   
 */
 
export const fetchCartDetails = createAsyncThunk('usercart/fetchCartDetails', async ({ token }, { rejectWithValue }) => {
    try {
        const res = await axios.get(API_BASE_URL + `/carts`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })

        return res.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message)
    }
});

/**
 * FETCH CURRENT USER CART DETAILS  
 */
 
export const fetchCurrentUserCartDetails = createAsyncThunk('usercart/fetchCurrentUserCartDetails', async ({ token, id }, { rejectWithValue }) => {
    try {
        const res = await axios.get(API_BASE_URL + `/cart/${id}`, {
            headers: {
                'Authorization': `Bearer ${token}`,
            }
        })

        return res.data;

    } catch (error) {
        return rejectWithValue(error.response ? error.response.data : error.message)
    }
});